const swipe = (
    elemento: HTMLElement,
    onSwipeLeft: () => void,
    onSwipeRight: () => void,
    umbral = 50,
    anguloMaximo = 30 // Ángulo máximo en grados para considerar un swipe horizontal
) => {
    let startX: number | undefined;
    let startY: number | undefined;
    let endX: number | undefined;
    let endY: number | undefined;
    let isDragging = false;

    const handleTouchStart = (e: TouchEvent) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
    };

    const handleTouchEnd = (e: TouchEvent) => {
        endX = e.changedTouches[0].clientX;
        endY = e.changedTouches[0].clientY;
        procesarSwipe();
    };

    const handleMouseDown = (e: MouseEvent) => {
        e.preventDefault();
        startX = e.clientX;
        startY = e.clientY;
        isDragging = true;

        document.addEventListener('mouseup', handleMouseUp);
        document.addEventListener('mousemove', handleMouseMove);

        elemento.style.userSelect = 'none';
        elemento.style.webkitUserSelect = 'none';
    };

    const handleMouseMove = (e: MouseEvent) => {
        if (!isDragging) return;
        e.preventDefault();
    };

    const handleMouseUp = (e: MouseEvent) => {
        endX = e.clientX;
        endY = e.clientY;
        isDragging = false;

        document.removeEventListener('mouseup', handleMouseUp);
        document.removeEventListener('mousemove', handleMouseMove);

        elemento.style.userSelect = '';
        elemento.style.webkitUserSelect = '';

        procesarSwipe();
    };

    const procesarSwipe = () => {
        if (!startX || !endX || !startY || !endY) return;

        const deltaX = startX - endX;
        const deltaY = startY - endY;

        // Calcular el ángulo del movimiento en grados
        const angulo = Math.abs(Math.atan2(deltaY, deltaX) * 180 / Math.PI);

        // Verificar si el movimiento es predominantemente horizontal
        const esHorizontal = angulo <= anguloMaximo || angulo >= (180 - anguloMaximo);

        if (Math.abs(deltaX) > umbral && esHorizontal) {
            if (deltaX > 0) {
                onSwipeLeft();
            } else {
                onSwipeRight();
            }
        }

        startX = undefined;
        startY = undefined;
        endX = undefined;
        endY = undefined;
    };

    // Instalar eventos
    elemento.addEventListener('touchstart', handleTouchStart, { passive: true });
    elemento.addEventListener('touchend', handleTouchEnd);
    elemento.addEventListener('mousedown', handleMouseDown);

    // Prevenir arrastre en imágenes
    elemento.querySelectorAll('img').forEach(img => {
        img.setAttribute('draggable', 'false');
        img.style.pointerEvents = 'none';
    });

    // Función para eliminar eventos
    const destruir = () => {
        elemento.removeEventListener('touchstart', handleTouchStart);
        elemento.removeEventListener('touchend', handleTouchEnd);
        elemento.removeEventListener('mousedown', handleMouseDown);
        document.removeEventListener('mouseup', handleMouseUp);
        document.removeEventListener('mousemove', handleMouseMove);
    };

    return { destruir };
};

export default swipe;